async function devtricker_process_readingListIconFill() {
    let loggedUserId = devtricker_getTheLoggedUserId()

    if (!loggedUserId) {
        return;
    }

    let postId = devtricker_getThePostId();

    let isPostInReadingListSession = devtricker_session_isPostInReadingList(postId);
    let isPostInReadingList = isPostInReadingListSession || await devtricker_ajax_checkIfPostIsInReadingList(postId);

    if (isPostInReadingList) {
        devTricker_changeReadingListIconTo('fill');
        devtricker_changeReadingListTooltipTextTo('Saved');
    }

    if(isPostInReadingList && !isPostInReadingListSession){
        devtricker_session_savePostInReadingList(postId);
    }
}

async function devtricker_toggleReadingList() {
    let loggedUserId = devtricker_getTheLoggedUserId();
    let postId = devtricker_getThePostId();

    if (!loggedUserId) {
        devtricker_openSocialLoginModal();
        return;
    }

    let action = await devtricker_process_getReadingListAction(postId);

    if (action == 'ADD') {
        devtricker_session_savePostInReadingList(postId);
        devTricker_changeReadingListIconTo('fill');
        devtricker_changeReadingListTooltipTextTo(g_devtricker_i18n.saved);

        devtricker_ajax_toggleReadingList(postId, action);

    } else if (action == 'REMOVE') {

        devtricker_session_deletePostFromReadingList(postId);
        devTricker_changeReadingListIconTo('default');
        devtricker_changeReadingListTooltipTextTo(g_devtricker_i18n.save);
        devtricker_ajax_toggleReadingList(postId, action);
    } else {
        throw new Error('Invalid action');
    }
}

function devtricker_process_getReadingListAction(postId) {
    const isInReadingList = devtricker_session_isPostInReadingList(postId);

    if (!isInReadingList) {
        return 'ADD';
    } else {
        return 'REMOVE';
    }
}

function devtricker_process_readingListIconFillV2(button) {
    const loggedUserId = devtricker_getTheLoggedUserId()

    if (!loggedUserId) {
        return;
    }

    const postId = button.getAttribute('data-post-id');

    let isPostInReadingList = devtricker_session_isPostInReadingList(postId);

    if (isPostInReadingList) {
        devtricker_dom_setchangeReadingListIconToFilledV2(button);
        devtricker_changeTooltipButtonTextToV2(button, "Saved");
    }
}

function devtricker_dom_setchangeReadingListIconToOriginalV2(button) {
    const userElement = button.querySelector("use");
    devtricker_changeIconToV2(userElement, 'feather-thin-bookmark');
}

function devtricker_dom_setchangeReadingListIconToFilledV2(button) {
    const userElement = button.querySelector("use");
    devtricker_changeIconToV2(userElement, 'feather-thin-bookmark-fill');
}